import { render } from "./OpenScreen.vue?vue&type=template&id=0f72be5e&scoped=true"
import script from "./OpenScreen.vue?vue&type=script&lang=js"
export * from "./OpenScreen.vue?vue&type=script&lang=js"

import "./OpenScreen.vue?vue&type=style&index=0&id=0f72be5e&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f72be5e"]])

export default __exports__